import { configureStore } from "@reduxjs/toolkit";
import controlPanelReducer from "./slices/controlPanelSlice";
export const store = configureStore({
    reducer: {
        controlPanel: controlPanelReducer,
    },
})